module.exports = __webpack_public_path__ + "static/media/align-justify.41b1a390.svg";